import { Box, Image, Tooltip,Text, WrapItem } from "@chakra-ui/react"

 export const Skill = ({img,name}) => {


  return (
    <WrapItem >
        
        <Tooltip label={name} hasArrow placement="top" >
             <Box boxSize={{base:"70px",sm:"80px", md:"90px",lg:"110px"}} >
              <Image boxSize={{base:"40px",sm:"50px", md:"60px",lg:"80px"}} src={img} m="auto" />
              <Text fontSize={["12px","14px"]} mt={"10px"} >{name}</Text>
             </Box>
        </Tooltip>

    </WrapItem>
  )
}
